import { DOCUMENT, Directive, ElementRef, OnDestroy, inject } from '@angular/core';

@Directive({
    selector: '[dsIosActive]',
    standalone: true,
})
export class DsIosActiveSupportDirective implements OnDestroy {
    private readonly isIOS: boolean;
    private readonly el = inject(ElementRef);
    private readonly document = inject(DOCUMENT);
    constructor() {
        const win = this.document.defaultView;
        this.isIOS = !!win && /iPad|iPhone|iPod/.test(win.navigator.userAgent) && !('MSStream' in win);

        if (this.isIOS) {
            this.el.nativeElement.classList.add('ds-ios-active-fix');
        }
    }

    ngOnDestroy(): void {
        if (this.isIOS) {
            this.el.nativeElement.classList.remove('ds-ios-active-fix');
        }
    }
}
